import { getCurrentInstance, computed, reactive } from 'vue';
import commonFn from '@/commons/commonFunction';
import { ModuleAccountCombo } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheAccountComboConfig = comboboxDataRemote => {
  const { proxy } = getCurrentInstance();

  /**
   * Load combo nếu Dboption tick hạn chế tài khoản
   * @param {*} keyRow Key của cột lọc tài khoản
   * @param {*} extend
   * @param {*} payload
   * NXCHIEN 10.07.2022
   */
  function buildFilterComboLocal(me, keyRow, extend, ors) {
    // Nếu cột lọc TK ko có giả trị thì bỏ qua tất cả;
    if (me.defaultData && me.defaultData[keyRow]) {
      let arrAccount = me.defaultData[keyRow].split(';');
      let accountFilter = commonFn.buildOrOpera(
        arrAccount,
        'account_number',
        proxy.$ms.constant.FilterOperator.StartsWith
      );

      let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
      extend.splice(0, extend.length);
      extend.push({
        Field: 'inactive',
        Value: false,
        Ors: ors,
      });
      extend.push({
        Field: 'is_parent',
        Value: false,
        Ors: orsIsParent,
      });
      extend.push(accountFilter);
    }
  }

  /**
   * Build Filter combo cho combo tài khoản
   * @param {*} me
   * @param {*} column
   * @returns
   * NXCHIEN 11.11.2022
   */
  const filterPayload = (me, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
    let ors2 = [{ Field: 'is_parent', Value: false, Ors: orsIsParent }];

    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      {
        Field: 'account_number',
        Operator: 'IN',
        Value: ['0061', '0062', '00811', '00812', '00813', '00821', '00822', '00823', '0091', '0092', '0093'],
        Ors: ors2,
      },
    ];

    // có tick hạn chế TK thì lấy dữ liệu cột Lọc trong TK ngầm định
    if (me.dbOptions?.AllowRestrictAccountNumber) {
      if (column.dataField == 'debit_account') {
        buildFilterComboLocal(me, 'default_debit_account_category_id', extend, ors);
      } else if (column.dataField == 'credit_account') {
        buildFilterComboLocal(me, 'default_credit_account_category_id', extend, ors);
      }
      //Thêm trường hợp là tài khoản thuế
      //TVDAT 15/07/2022
      else if (column.dataField == 'tax_account') {
        buildFilterComboLocal(me, 'default_tax_account_category_id', extend, ors);
      }
    }
    return extend;
  };

  const filterPayloadParalell = (me, column) => {
    let ors = [{ Field: 'inactive', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let orsIsParent = [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
      {
        Field: 'account_number',
        Value: '0',
        Operator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
    ];

    return extend;
  };

  const filterPayloadOrgPriceFixedAsset = (me, column) => {
    let ors = [{ Field: 'inactive', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let orsIsParent = [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
      {
        Field: 'account_number',
        Value: '0',
        Operator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
    ];

    return extend;
  };

  const store = useStore();

  const accountDebit = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let filters = filterPayload(proxy, {
      dataField: 'debit_account',
    });
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  const accountCredit = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let filters = filterPayload(proxy, {
      dataField: 'credit_account',
    });
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  const accountTax = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let filters = filterPayload(proxy, {
      dataField: 'tax_account',
    });
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  const accountDebitParalell = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let filters = filterPayloadParalell(proxy, {
      dataField: 'debit_account',
    });
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  const accountCreditParalell = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let filters = filterPayloadParalell(proxy, {
      dataField: 'credit_account',
    });
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  const accountMostDetail = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let filters = filterPayload(proxy, {
      dataField: '',
    });
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  const accountOrgPriceFixedAsset = computed(() => {
    const accountCombos = store.getters[`${ModuleAccountCombo}/items`];
    let ors = [{ Field: 'inactive', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let orsIsParent = [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
      {
        Field: 'account_number',
        Value: '211',
        Operator: proxy.$ms.constant.FilterOperator.StartsWith,
        Ors: [
          {
            Field: 'account_number',
            Value: '213',
            Operator: proxy.$ms.constant.FilterOperator.StartsWith,
          },
        ],
      },
    ];
    let filters = extend;
    let value = commonFn.filterArray(accountCombos, filters);
    return value;
  });

  // config columns combo
  const cacheAccountComboConfig = {
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'local',
    dropdownWidth: 600,
  };

  const cacheAccountDebitCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountDebit },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản',
      },
    },
  });

  const cacheAccountCreditCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountCredit },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản',
      },
    },
  });

  const cacheAccountTaxCreditCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountTax },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản thuế',
      },
    },
  });

  const cacheAccountDebitParalellCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountDebitParalell },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản',
      },
    },
  });
  const cacheAccountCreditParalellCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountCreditParalell },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản',
      },
    },
  });

  const cacheAccountMostDetailCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountMostDetail },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản giá vốn',
      },
    },
  });

  const cacheAccountOrgPriceFixedAsset = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountOrgPriceFixedAsset },
  });

  const cacheAccountCombo = reactive({
    ...cacheAccountComboConfig,
    ...{ data: accountMostDetail },
    ...{
      quickSearch: 'LocalQuickSearchPopup',
      quickSearchParam: {
        idField: 'account_number',
        titleSearch: 'Tìm nhanh tài khoản',
      },
    },
  });
  return {
    cacheAccountDebitCombo,
    cacheAccountCreditCombo,
    cacheAccountTaxCreditCombo,
    cacheAccountDebitParalellCombo,
    cacheAccountCreditParalellCombo,
    cacheAccountMostDetailCombo,
    cacheAccountOrgPriceFixedAsset,
    cacheAccountCombo,
  };
};
